import { toDisplayString as _toDisplayString, vShow as _vShow, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7586cfb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "detail-container"
}
const _hoisted_3 = { class: "detail-row" }
const _hoisted_4 = { class: "prompt" }
const _hoisted_5 = { class: "detail-row" }
const _hoisted_6 = { class: "prompt" }
const _hoisted_7 = { class: "detail-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Table:", -1))
const _hoisted_9 = { class: "detail-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Query Coordinates:", -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _directive_hide = _resolveDirective("hide")!

  return (_openBlock(), _createElementBlock("div", {
    id: "root-container",
    onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hasFocus = true)),
    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hasFocus = false)),
    onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hasFocus = true)),
    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hasFocus = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("label", {
        focusable: "false",
        id: "name-label",
        class: "ellipsize",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSelected = !_ctx.isSelected)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.isSelected = !_ctx.isSelected), ["enter"]))
      }, _toDisplayString(_ctx.source.name), 545), [
        [_vShow, !_ctx.editing]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "name-input",
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = false))
      }, null, 544), [
        [_vShow, _ctx.editing]
      ]),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: _normalizeClass(['icon-button', { 'icon-active': _ctx.editing }]),
        icon: "pencil-alt",
        onClick: _ctx.handleEditClick
      }, null, 8, ["class", "onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ]),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: "map-marker-alt",
        onClick: _ctx.handleMarkerClick
      }, null, 8, ["onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ]),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: "times",
        onClick: _ctx.handleDelete
      }, null, 8, ["onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ])
    ]),
    _createVNode(_component_transition_expand, null, {
      default: _withCtx(() => [
        (_ctx.isSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString("lng" in _ctx.source ? "Lon:" : "RA:"), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.lngStr), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString("lat" in _ctx.source ? "Lat:" : "Dec:"), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.latStr), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(_ctx.source.catalogLayer.name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("a", {
                  href: _ctx.simbadCoordinatesURL,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "SIMBAD", 8, _hoisted_11),
                _createTextVNode(" | "),
                _createElementVNode("a", {
                  href: _ctx.nedCoordinatesURL,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "NED", 8, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}